import {
  selectIsTraderLoading,
  selectIsTraderVerified,
  selectTrader,
  selectTraderError,
} from '@/entities/trader'
import {
  selectIsMerchantLoading,
  selectIsMerchantVerified,
  selectMerchant,
  selectMerchantError,
} from '@/entities/merchant'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { Roles } from '@/entities/roles'
import { useAppSelector } from '@/store/hooks'

export const useActiveUser = () => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)

  const userData =
    userRole === Roles.Trader ? useAppSelector(selectTrader) : useAppSelector(selectMerchant)

  const isVerified =
    userRole === Roles.Trader
      ? useAppSelector(selectIsTraderVerified)
      : useAppSelector(selectIsMerchantVerified)

  const isLoading =
    userRole === Roles.Trader
      ? useAppSelector(selectIsTraderLoading)
      : useAppSelector(selectIsMerchantLoading)

  const error =
    userRole === Roles.Trader
      ? useAppSelector(selectTraderError)
      : useAppSelector(selectMerchantError)

  return { userData, userRole, isLoading, isVerified, error }
}
